import React, { useEffect, useState, useMemo } from "react"
import { get, isEmpty } from "lodash"

import { NikkeiAverageTemplate } from "components/templates/domestic/nikkei"
import { APIResponse } from "redux/apis/types"
import APIs from "redux/apis"
import { EXCHANGE, SECURITY_TYPE } from "config/const"
import uuid from "uuid"
import store from "redux/store"
import { pageLoadRegist } from "redux/ducks/PageLoad"
import { useLodingTrigger, LoadingTriger } from "components/actions/loading"
import { LoadStateType } from "redux/ducks/PageLoad"
import { useSelector } from "react-redux"

export const Nikkei = () => {
  const [nikkeiData, setData] = useState<APIResponse.Res>()
  const [detailsData, setDetailsData] = useState<APIResponse.Res>()
  const loadResistId = useMemo(() => uuid(), [])
  const { loading, setLoading } = useLodingTrigger()
  const isPageLoading = useSelector(
    (state: { PageLoad: LoadStateType }) => state.PageLoad.load
  )

  const requestData = async () => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const data = await APIs.SymbolDetail.EquitySymbolList({
      IndexKeyword: "NK225",
    })
    setData(data)
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  const requestDetailsData = async (data: object) => {
    store.dispatch(pageLoadRegist(loadResistId, true))
    const symbolDetail = await APIs.SymbolDetail.SymbolDetail({
      Symbol: get(data, "Symbol"),
      Exchange: get(data, "Exchange", EXCHANGE.TSE.id),
      SecurityType: get(data, "SecurityType", SECURITY_TYPE.Equity.id),
    })
    setDetailsData(get(symbolDetail, "Symbol"))
    store.dispatch(pageLoadRegist(loadResistId, false))
  }

  useEffect(() => {
    requestData()
  }, [])

  //ページ更新
  useEffect(() => {
    if (isPageLoading) requestData()
  }, [isPageLoading])

  useEffect(() => {
    if (!loading) return
    setLoading(false)
    requestData()
  }, [loading])

  useEffect(() => {
    const data = get(nikkeiData, "ResultList")
    if (isEmpty(nikkeiData)) return
    requestDetailsData(data[0])
  }, [nikkeiData])

  return (
    <LoadingTriger.Provider value={{ loading, setLoading }}>
      <NikkeiAverageTemplate
        data={nikkeiData}
        detailsData={detailsData}
        requestDetailsData={requestDetailsData}
      />
    </LoadingTriger.Provider>
  )
}
